module.exports = __webpack_public_path__ + "img/onboarding-girl.8c3f4e50.png";